<script>
    export let fill = '#FFF'
</script>

<style>
    svg#team-info-links {
        position: absolute;
        width: 434.58px;
        height: 265.6px;
        top: 382px;
        left: 52px;
    }

    .cls-1 {
        font-size: 12px;
    }
    .cls-1,
    .cls-8 {
        font-family: AvenirNext-Regular, Avenir Next;
    }
    .cls-2 {
        letter-spacing: -0.01em;
    }
    .cls-3 {
        letter-spacing: -0.1em;
    }
    .cls-4 {
        letter-spacing: -0.01em;
    }
    .cls-5 {
        letter-spacing: -0.02em;
    }
    .cls-6 {
        letter-spacing: -0.01em;
    }
    .cls-7 {
        letter-spacing: -0.01em;
    }
    .cls-8 {
        font-size: 10px;
    }
    .cls-9 {
        letter-spacing: -0.05em;
    }
</style>

<svg id="team-info-links" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 434.58 265.6">
    <defs />
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <text {fill} class="cls-1" transform="translate(1.47 10.25)">Go to team schedule</text>
            <text {fill} class="cls-1" transform="translate(2.54 55.55)">Go to team news</text>
            <text {fill} class="cls-1" transform="translate(0 99.85)">Team preferences</text>
            <text {fill} class="cls-1" transform="translate(2.07 145.15)">Get tickets</text>
            <text {fill} class="cls-1" transform="translate(2.54 190.26)">Conference Standings</text>
            <text {fill} class="cls-1" transform="translate(2.61 234.56)">Conference Results</text>
            <text {fill} class="cls-8" transform="translate(277.2 110.65)">Following</text>
        </g>
    </g>
</svg>
